import React, { Component } from "react";
import PropTypes from "prop-types";
import utils from "@utils";
import { InvoiceService } from "@services";
import classNames from "classnames";
import { Modal, Loader } from "../../../../../components";

import "./NonRKPayInvoiceStatusHistoryModal.scss";

class NonRKPayInvoiceStatusHistoryModal extends Component {
	constructor(props) {
		super(props);

		this.state = {
			invoiceStatusHistoryList: [],
			historyItem: {},
			isLoading: false,
		};
	}

	componentDidUpdate(prevProps) {
		const { show, invoiceId } = this.props;
		if (prevProps.show !== show && show) {
			this.getInvoiceStatusHistory(invoiceId);
		}
	}

	/**
	 * Retrieves the status hitsory of the invoice
	 * @param {*} invoiceId The uniqe id of the invoice
	 */
	getInvoiceStatusHistory = invoiceId => {
		const { lang } = global;
		const { historyItem } = this.state;
		this.setState({ isLoading: true });
		InvoiceService.getNonRKPayInvoiceStatusHistory(invoiceId)
			.then(({ data }) => {
				const invoiceStatusHistoryList = data.map((status, order) => ({
					...status,
					order,
				}));
				invoiceStatusHistoryList.forEach(status => {
					if (!historyItem[status.order])
						historyItem[status.order] = { showDetails: false };
				});
				this.setState({
					invoiceStatusHistoryList: invoiceStatusHistoryList.reverse(),
					historyItem,
				});
			})
			.catch(() => {
				utils.notify({
					type: "error",
					message: lang.t("Error loading invoice status history"),
					title: "Error",
				});
			})
			.finally(() => this.setState({ isLoading: false }));
	};

	handleOnClose = () => {
		const { onClose } = this.props;
		this.setState({
			invoiceStatusHistoryList: [],
			historyItem: {},
			isLoading: false,
		});
		onClose();
	};

	toggleShowDetails = id =>
		this.setState(prevState => ({
			historyItem: {
				...prevState.historyItem,
				[id]: {
					...prevState.historyItem[id],
					showDetails: !prevState.historyItem[id].showDetails,
				},
			},
		}));

	render() {
		const { lang } = global;
		const { show, user } = this.props;
		const { invoiceStatusHistoryList, historyItem, isLoading } = this.state;

		const userTypeMapping = {
			1: "Admin",
			10: "Officer",
			20: "Client",
			30: "SecurityAgency",
			40: "LEA",
			50: "Coordinator",
		};

		return (
			<Modal
				id="invoice-status-history-modal"
				size="lg"
				show={show}
				onHide={() => this.handleOnClose()}
			>
				<Modal.Header closeButton>
					<Modal.Title>{lang.t("History")}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="invoice-status-history-table">
						<div className="history-table-header hidden-xs">
							<div className="row">
								<strong className="col-sm-2">{lang.t("Date")}</strong>
								<strong className="col-sm-2">{lang.t("Time")}</strong>
								<strong className="col-sm-2">{lang.t("Invoice Status")}</strong>
								<strong className="col-sm-2">{lang.t("Changed By")}</strong>
								<strong className="col-sm-2">{lang.t("User Type")}</strong>
							</div>
						</div>
						<div className="history-table-body">
							<Choose>
								<When condition={invoiceStatusHistoryList.length > 0}>
									<For
										each="statusEvent"
										of={invoiceStatusHistoryList}
										index="index"
									>
										<div
											className="invoice-status-history-item"
											key={`${statusEvent}_${index}`}
										>
											<div
												className={`collapsing-panel row${historyItem[statusEvent.order].showDetails ? " expanded" : ""}`}
											>
												<div className="col-xs-4 col-sm-2 col-md-2">
													{utils.formatDate(
														new Date(`${statusEvent.CreateDateUTC}Z`),
														"en-US",
														user.TimeZoneId,
														"numeric",
													)}
												</div>
												<div className="col-xs-4 col-sm-2">
													{utils.formatTime(
														new Date(`${statusEvent.CreateDateUTC}Z`),
														"en-US",
														user.TimeZoneId,
														"numeric",
													)}
												</div>
												<div className="col-xs-4 col-sm-2 event-type-name">
													{statusEvent.EventTypeName}
												</div>
												<div className="col-xs-10 col-sm-2 col-md-2">
													{statusEvent.CreatedByName}
												</div>
												<div className="col-xs-12 col-sm-4 col-md-2">
													{userTypeMapping[statusEvent.UserTypeId]}
												</div>
												<If condition={statusEvent.Metadata}>
													<div className="col-xs-12 col-sm-2">
														<button
															type="button"
															className="btn btn-link btn-block"
															onClick={() =>
																this.toggleShowDetails(
																	statusEvent.order,
																)
															}
														>
															{lang.t("Details")}
															<i
																title="View Details"
																className={classNames(
																	"rkf chevron-icon",
																	{
																		"rkf-chevron-down":
																			!historyItem[
																				statusEvent.order
																			].showDetails,
																		"rkf-chevron-up":
																			historyItem[
																				statusEvent.order
																			].showDetails,
																	},
																)}
															/>
														</button>
													</div>
													<If
														condition={
															historyItem[statusEvent.order]
																.showDetails
														}
													>
														<div className="metadata-details">
															<For
																each="key"
																of={Object.keys(
																	statusEvent.Metadata,
																)}
																index="index"
															>
																<div
																	className="col-xs-12 expanded-details"
																	key={`metada_${key}_${index}`}
																>
																	<div className="row">
																		<div className="col-sm-offset-1 col-sm-11">
																			<strong>{`${key}: `}</strong>
																			{`${
																				statusEvent.Metadata[
																					key
																				].indexOf("Sent To")
																					? statusEvent.Metadata[
																							key
																						].replaceAll(
																							",",
																							", ",
																						)
																					: statusEvent
																							.Metadata[
																							key
																						]
																			}`}
																		</div>
																	</div>
																</div>
															</For>
														</div>
													</If>
												</If>
											</div>
										</div>
									</For>
								</When>
								<Otherwise>
									<div className="col-xs-12 text-center text-muted display-empty">
										{lang.t("No statuses changes to display")}
									</div>
								</Otherwise>
							</Choose>
							<Loader
								active={isLoading}
								size="small"
							/>
						</div>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<button
						type="button"
						className="btn btn-primary"
						id="close-invoice-status-history-modal"
						onClick={() => this.handleOnClose()}
					>
						{lang.t("Close")}
					</button>
				</Modal.Footer>
			</Modal>
		);
	}
}

export default NonRKPayInvoiceStatusHistoryModal;

NonRKPayInvoiceStatusHistoryModal.propTypes = {
	show: PropTypes.bool,
	onClose: PropTypes.func,
	user: PropTypes.any.isRequired,
	invoiceId: PropTypes.string,
};

NonRKPayInvoiceStatusHistoryModal.defaultProps = {
	show: false,
	onClose: () => {},
	invoiceId: undefined,
};
